import TechSkills from "./TechSkills";

const coreCompetencies = [
  "Artificial Intelligence (AI)",
  "Generative AI",
  "Agentic AI",
  "AI Agents",
  "Microsoft Azure",
  "Research and Development (R&D)",
  "Full Stack Development (MERN)",
  "UI/UX Design",
];

export default function Skills() {
  return (
    <section id="skills" className="bg-gray-900 py-14">
      <div className="mx-auto max-w-screen-xl px-4 md:px-8">
        {/* Core Competencies */}
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-white text-3xl font-semibold sm:text-4xl">
            My Core Competencies
          </h2>
          <p className="mt-2 text-gray-400 text-sm">
            Areas I focus on while building AI-powered and full-stack solutions.
          </p>
        </div>

        <div className="mt-10 flex justify-center">
          <ul className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
            {coreCompetencies.map((competency) => (
              <li
                key={competency}
                className="rounded-lg border border-white/10 bg-white/5 px-4 py-3 text-sm text-gray-200 text-center hover:bg-white/10 transition"
              >
                {competency}
              </li>
            ))}
          </ul>
        </div>

        {/* Technical Proficiency */}
        <div className="mt-14">
          <h2 className="text-white text-3xl font-semibold sm:text-4xl text-center">
            Technical Proficiency
          </h2>

          <div className="mt-8">
            <TechSkills />
          </div>
        </div>
      </div>
    </section>
  );
}
